// A skilldar chart has data when at least one of its skills is above zero (careers without skills data come back all zeros)
export const hasSkillsData = (chart) =>
  Array.isArray(chart?.series?.[0]?.data) && chart.series[0].data.some((value) => Number(value) > 0);
